import { jsNode } from '@shared/node-v1.0.0'

import v010 from '@nodes/use-local-data-v0.1.0'

export default jsNode(
	'useLocalData',
	{
		'v0.1.0': v010,
	},
	{ docs: 'https://docs.rolder.app/#/useLocalData' }
)
